import { render, staticRenderFns } from "./PermissionAttendance.vue?vue&type=template&id=c8598af0&scoped=true"
import script from "./PermissionAttendance.vue?vue&type=script&lang=js"
export * from "./PermissionAttendance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8598af0",
  null
  
)

export default component.exports